import { environmentBase } from './environment.base';
import { getApmHost,getCrosstalkRoot, getEnvironment, getReportRunnerLocation } from './utils';

export const environment = {
    ...environmentBase,
    production: true,
    api: './named-query/api',
    apm: {
        environment: getEnvironment(window.location),
        active: true,
        host: getApmHost(window.location.hostname),
    },
};

(environment.reportRunnerLocation).hostAndPort = getReportRunnerLocation(window.location);
(environment.crosstalk).hostAndPort = getCrosstalkRoot(window.location);
